// internal
const addressFormsTitles = {
  address: 'Immobilien-Straße',
  street: 'Immobilien Strasse',
  houseNumber: 'Immobilien-Hausnummer',
  zip: 'Immobilien-Postleitzahl',
  city: 'Immobilien-Stadt',
  state: 'Immobilien-Bundesland'
}

// external
export const slideNames = {
  SLIDE_0: 'slide-00', // HW - Ihr Immobilientyp
  SLIDE_1: 'slide-01', // H - Ihr Haustyp
  SLIDE_2: 'slide-02', // HW - Ihr geschätzter Immobilienwert & Ihre Wunschauszahlung
  SLIDE_3: 'slide-03', // HW - Lasten der Immobilie & Höhe der Lasten
  SLIDE_19: 'slide-04', // HW - Adresse der Immobilie
  SLIDE_4: 'slide-05', // H - Anzahl der Geschosse & Grundstücksfläche
  SLIDE_5: 'slide-06', // HW - Baujahr & Wohnfläche
  SLIDE_23: 'slide-07', // W - Wohneinheiten & Geschosslage
  SLIDE_6: 'slide-08', // H - Bauweise
  SLIDE_7: 'slide-09', // H - Ausbau des Kellers
  SLIDE_8: 'slide-10', // H - Dachgeschoss
  SLIDE_9: 'slide-11', // HW - Ihre Stellplätze
  SLIDE_10: 'slide-12', // W - Ausstattung (Balkon/Terrasse, Garten)
  SLIDE_12: 'slide-13', // W - Ausstattung (Außenwände gedämmt, Gäste-WC)
  SLIDE_11: 'slide-14', // H - Ausstattung (Gäste-WC, Kamin/Kachelofen, Bad, auf Putz …)
  SLIDE_13: 'slide-15', // H - Objektinformationen
  SLIDE_14: 'slide-16', // W - Objektinformationen
  SLIDE_16: 'slide-17', // HW - Energieeffizienzklasse & Energieeffizienshausstandard
  SLIDE_17: 'slide-18', // HW - Relevante Modernisierungen
  SLIDE_18: 'slide-19', // HW - Zeitraum der letzten Modernisierung
  SLIDE_20: 'slide-20', // HW - Angebot der Deutschen Teilkauf
  SLIDE_24: 'slide-24', // HW - Adresse der Immobilie v2
  SLIDE_21: 'slide-21', // HW - Kontaktdaten
  SLIDE_22: 'slide-22' // HW - Danksagung
}

export const formNames = {
  FORM_0_1: { name: '00N3V000000sVVh', title: 'Objektart', value: '' },
  FORM_0_2: {
    name: '00N3V000000sVVm',
    title: 'Eigentumsform',
    value: ''
  },
  FORM_1_1: {
    name: '00N3V000000sVVr',
    title: 'Gebäudeart',
    value: ''
  },
  FORM_2_1: {
    name: '00N3V000000w6EZ',
    title: 'Geschätzter Immobilienwert',
    value: 500000
  },
  FORM_2_2: {
    name: '00N3V000000w6Ee',
    title: 'Wunschbetrag',
    value: 100000
  },
  FORM_3_1: {
    name: '00N3V000000w6Eo',
    title: 'Bestehende Lasten?',
    value: ''
  },
  FORM_3_2: {
    name: '00N3V000000wLhN',
    title: 'Bestehende Lasten (Betrag)',
    value: ''
  },
  FORM_4_1: {
    name: '00N3V000000sTk1',
    title: 'Anzahl Geschosse (ohne DG und KG)',
    value: ''
  },
  FORM_4_2: {
    name: '00N3V000000w6F3',
    title: 'Grundstücksfläche in m²',
    value: ''
  },
  FORM_5_1: {
    name: '00N3V000000wfxh',
    title: 'Baujahr',
    value: 1900
  },
  FORM_5_2: {
    name: '00N3V000000w6Ey',
    title: 'Wohnfläche in m²',
    value: 50
  },
  FORM_6_1: {
    name: '00N3V000000sTkQ',
    title: 'Bauweise',
    value: ''
  },
  FORM_7_1: {
    name: '00N3V000000sTjD',
    title: 'Kellerart',
    value: ''
  },
  FORM_7_2: {
    name: '00N3V000000sTj8',
    title: 'Kellerausbau (für Wohnnutzung)',
    value: ''
  },
  FORM_8_1: {
    name: '00N3V000000sTj3',
    title: 'Dachausbau',
    value: ''
  },
  FORM_9_1: {
    name: '00N3V000000sTjI',
    title: 'Garagenstellplätze (Anzahl)',
    value: ''
  },
  FORM_9_2: {
    name: '00N3V000000sZ8c',
    title: 'Aussenstellplätze (Anzahl)',
    value: ''
  },
  FORM_10_1: {
    name: '00N3V000000sVW6',
    title: 'Außenwohnbereich',
    value: ''
  },
  FORM_10_2: {
    name: '00N3V000000w6FN',
    title: 'Garten',
    value: ''
  },
  FORM_11_1: {
    name: '00N3V000000sTjN',
    title: 'mehr als ein Bad',
    value: ''
  },
  FORM_11_2: {
    name: '00N3V000000sTjm',
    title: 'offener Kamin / Kachelofen',
    value: ''
  },
  FORM_11_3: {
    name: '00N3V000000sTjS',
    title: 'separates Gäste-WC',
    value: ''
  },
  FORM_11_4: {
    name: '00N3V000000sTjX',
    title: 'Sauna',
    value: ''
  },
  FORM_11_5: {
    name: '00N3V000000sTjh',
    title: 'Außenwände überwiegend gedämmt',
    value: ''
  },
  FORM_11_6: {
    name: '00N3V000000sTjc',
    title: 'Leitungen überwiegend auf Putz',
    value: ''
  },
  FORM_12_1: {
    name: '00N3V000000sTjh',
    title: 'Sind die Außenwände überwiegend gedämmt?',
    value: ''
  },
  FORM_12_2: {
    name: '00N3V000000sTjS',
    title: 'Besitzt die Wohnung ein sepreates Gäste WC?',
    value: ''
  },
  FORM_13_1: {
    name: '00N3V000000wVn2',
    title: 'Heizung',
    value: ''
  },
  FORM_13_2: {
    name: '00N3V000000wVlp',
    title: 'Dacheindeckung',
    value: ''
  },
  FORM_13_3: {
    name: '00N3V000000wVmO',
    title: 'Fenster',
    value: ''
  },
  FORM_13_4: {
    name: '00N3V000000axxZ',
    title: 'Anzahl Einheiten MFH',
    value: ''
  },
  FORM_13_5: {
    name: '00N3V000000axxU',
    title: 'Aussenwohnbereich MFH',
    value: ''
  },
  FORM_14_1: {
    name: '00N3V000000wVmO',
    title: 'Fenster',
    value: ''
  },
  FORM_14_2: {
    name: '00N3V000000sVVw',
    title: 'Badtyp',
    value: ''
  },
  FORM_14_3: {
    name: '00N3V000000wVn2',
    title: 'Heizung',
    value: ''
  },
  FORM_14_4: {
    name: '00N3V000000sVW1',
    title: 'Abstellraum',
    value: ''
  },
  FORM_14_5: {
    name: '00N3V000000sVWB',
    title: 'Fußbodenbelag Wohnzimmer',
    value: ''
  },
  FORM_16_1: {
    name: '00N3V000000sTjw',
    title: 'Energieeffizienzklasse',
    value: ''
  },
  FORM_16_2: {
    name: '00N3V000000sTjr',
    title: 'Energieeffizienzhausstandard',
    value: ''
  },
  FORM_17_1: {
    name: '00N3V000000sTiK',
    title: 'Bodenbeläge - Modernisierung',
    value: ''
  },
  FORM_17_2: {
    name: '00N3V000000sTio',
    title: 'Strom- Wasser- Heizg- Ltg Modernisierung',
    value: ''
  },
  FORM_17_3: {
    name: '00N3V000000sTiZ',
    title: 'Fenster  - Modernisierung',
    value: ''
  },
  FORM_17_4: {
    name: '00N3V000000sTiP',
    title: 'Bäder und WCs  - Modernisierung',
    value: ''
  },
  FORM_17_5: {
    name: '00N3V000000sTiU',
    title: 'Heizung  - Modernisierung',
    value: ''
  },
  FORM_17_6: {
    name: '00N3V000000sTit',
    title: 'Raumaufteilung  - Modernisierung',
    value: ''
  },
  FORM_17_7: {
    name: '00N3V000000sTij',
    title: 'Wärmedämmung - Modernisierung',
    value: ''
  },
  FORM_17_8: {
    name: '00N3V000000sTie',
    title: 'Dach  - Modernisierung',
    value: ''
  },
  FORM_18_1: {
    name: '00N3V000000sgLT',
    title: 'letzte Modernisierung',
    value: ''
  },
  FORM_19_1: {
    name: '00N3V000000wikR',
    // has to be same as 21
    title: addressFormsTitles.address,
    value: ''
  },
  FORM_19_1_1: {
    name: '00N3V000000aylj',
    // has to be same as 21
    title: addressFormsTitles.street,
    value: ''
  },
  FORM_19_1_2: {
    name: '00N3V000000aylU',
    // has to be same as 21
    title: addressFormsTitles.houseNumber,
    value: ''
  },
  FORM_19_2: {
    name: '00N3V000000wikb',
    // has to be same as 21
    title: addressFormsTitles.zip,
    value: ''
  },
  FORM_19_3: {
    name: '00N3V000000wikW',
    // has to be same as 21
    title: addressFormsTitles.city,
    value: ''
  },
  FORM_19_4: {
    name: '00N9Y000000Ovkb',
    // has to be same as 21
    title: addressFormsTitles.state,
    value: ''
  },
  FORM_20_1: {
    send: false,
    name: 'calculation',
    title: 'Angebot der Deutschen Teilkauf',
    value: ''
  },
  FORM_21_1: {
    name: 'salutation',
    title: 'Salutation',
    value: ''
  },
  FORM_21_2: {
    name: 'title',
    title: 'Title',
    value: ''
  },
  FORM_21_3: {
    name: 'first_name',
    title: 'first_name',
    value: ''
  },
  FORM_21_4: {
    name: 'last_name',
    title: 'last_name',
    value: ''
  },
  FORM_21_5: {
    name: 'email',
    title: 'email',
    value: ''
  },
  FORM_21_6: {
    name: 'mobile',
    title: 'mobile',
    value: ''
  },
  FORM_21_7: {
    send: false,
    name: 'checkbox-1',
    title: 'checkbox-1',
    value: ''
  },
  FORM_21_13: {
    send: true,
    name: '00N3V000000b00a',
    title: 'Angebot digital',
    value: ''
  },
  FORM_21_8: {
    name: 'street',
    // has to be same as 19
    title: addressFormsTitles.address,
    value: ''
  },
  FORM_21_8_1: {
    name: '00N3V000000aylo',
    // has to be same as 19
    title: addressFormsTitles.street,
    value: ''
  },
  FORM_21_8_2: {
    name: '00N3V000000wfxc',
    // has to be same as 19
    title: addressFormsTitles.houseNumber,
    value: ''
  },
  FORM_21_9: {
    name: 'zip',
    // has to be same as 19
    title: addressFormsTitles.zip,
    value: ''
  },
  FORM_21_10: {
    name: 'city',
    // has to be same as 19
    title: addressFormsTitles.city,
    value: ''
  },
  FORM_21_11: {
    name: '00N3V000000wiiL',
    title: 'Nachricht',
    value: ''
  },
  FORM_21_12: {
    name: '00N3V000000wj7V',
    title: 'Datenschutz',
    value: ''
  },
  FORM_22_1: {
    send: false,
    name: 'Thankyou',
    title: 'Thankyou',
    value: ''
  },
  FORM_23_1: {
    name: '00N3V000000shW3',
    title: 'Geschosslage',
    value: ''
  },
  FORM_23_2: {
    name: '00N3V000000axbJ',
    title: 'Anzahl der Wohneinheiten',
    value: 1
  }
}

export const hiddenInputs = {
  // INPUT_0: {
  //   type: 'input',
  //   form_name: 'form_debug',
  //   name: 'debug',
  //   value: '',
  //   mandatory: false
  // },
  // INPUT_1: {
  //   type: 'input',
  //   form_name: 'form_debugemail',
  //   name: 'debugEmail',
  //   value: '',
  //   mandatory: false
  // },
  INPUT_2: {
    type: 'input',
    form_name: 'form_oid',
    name: 'oid',
    value: '00D3V000000Cc3r',
    mandatory: true
  },
  INPUT_3: {
    type: 'input',
    form_name: 'form_returl',
    name: 'retURL',
    value: 'https://deutsche-teilkauf.de/',
    mandatory: true
  },
  INPUT_4: {
    type: 'input',
    form_name: 'form_leadorigin',
    name: '00N3V000000wjXx',
    value: 'Website - Angebot guided',
    mandatory: true
  },
  INPUT_5: {
    type: 'input',
    form_name: 'form_website',
    name: '00N3V000000sSmB',
    value: 'deutsche-teilkauf.de/immobilien-teilverkauf',
    mandatory: true
  },
  // INPUT_6: {
  //   type: 'textarea',
  //   form_name: 'form_msclkid',
  //   name: '00N3V000000sV0j',
  //   value: 'false',
  //   mandatory: true
  // },
  // INPUT_7: {
  //   type: 'textarea',
  //   form_name: 'form_fbclip',
  //   name: '00N3V000000sV0o',
  //   value: 'false',
  //   wrap: 'soft',
  //   mandatory: true
  // },
  // INPUT_8: {
  //   type: 'textarea',
  //   form_name: 'form_utm',
  //   name: '00N3V000000sTMY',
  //   value: 'false',
  //   wrap: 'soft',
  //   mandatory: true
  // },
  // INPUT_9: {
  //   type: 'input',
  //   form_name: 'form_gaclientid',
  //   name: '00N3V000000wwka',
  //   id: '00N3V000000wwka',
  //   value: ''
  // },
  // INPUT_10: {
  //   type: 'input',
  //   form_name: 'form_gauserid',
  //   name: '00N3V000000wwkk',
  //   id: '00N3V000000wwkk',
  //   value: ''
  // },
  // INPUT_11: {
  //   type: 'input',
  //   form_name: 'form_gatrackid',
  //   name: '00N3V000000wwkp',
  //   id: '00N3V000000wwkp',
  //   value: ''
  // },
  // INPUT_13: {
  //   type: 'input',
  //   form_name: 'form_faorderid',
  //   name: '00N3V000000sZGM',
  //   id: '00N3V000000sZGM',
  //   value: 'false',
  //   mandatory: true
  // },
  // INPUT_12: {
  //   type: 'input',
  //   form_name: 'form_gclid',
  //   name: '00N3V000000wjXn',
  //   id: '00N3V000000wjXn',
  //   value: 'false',
  //   mandatory: true
  // },
  // HONEYPOT FIELD
  INPUT_14: {
    type: 'honeypot',
    name: '00N3V000000b1gN',
    id: '00N3V000000b1gN',
    value: '',
    mandatory: false
  },
  // DESIGN INPUT
  INPUT_15: {
    type: 'input',
    form_name: 'form_design',
    name: '00N3V000000b9rX',
    id: '00N3V000000b9rX',
    // default value, if hausanker -> 'HA'
    value: 'DTK',
    mandatory: true
  }
}

export const formTypes = {
  RADIO_BOX: 1,
  RADIO_VERTICAL: 2,
  RADIO_HORIZONTAL: 3,
  SELECT: 4,
  TEXT_INPUT: 5,
  CHECKBOX: 6,
  TEXTAREA: 7,
  RANGE: 8,
  RADIO_TABLE: 9,
  CALCULATION: 10,
  TEXT: 11,
  MULTI_CHECKS: 12,
  RADIO_COMBO: 13
}

export const messages = [
  {
    name: slideNames.SLIDE_2, // HW - Ihr geschätzter Immobilienwert & Ihre Wunschauszahlung
    messages: [
      'Ihrer Wohnung',
      'Ihres Einfamilienhauses',
      'Ihrer Doppelhaushälfte',
      'Ihres Reihenendhauses',
      'Ihres Einfamilienhauses',
      'Ihres Reihenmittelhauses',
      'Ihres Zweifamilienhauses',
      'Ihres Mehrfamilienhauses'
    ]
  },

  {
    name: slideNames.SLIDE_4, // H - Anzahl der Geschosse & Grundstücksfläche
    messages: [
      'Ihrer Wohnung',
      'Ihres Einfamilienhauses',
      'Ihrer Doppelhaushälfte',
      'Ihres Reihenendhauses',
      'Ihres Einfamilienhauses',
      'Ihres Reihenmittelhauses',
      'Ihres Zweifamilienhauses',
      'Ihres Mehrfamilienhauses'
    ]
  },
  {
    name: slideNames.SLIDE_5, // HW - Baujahr & Wohnfläche
    messages: [
      'Ihrer Wohnung',
      'Ihres Einfamilienhauses',
      'Ihrer Doppelhaushälfte',
      'Ihres Reihenendhauses',
      'Ihres Einfamilienhauses',
      'Ihres Reihenmittelhauses',
      'Ihres Zweifamilienhauses',
      'Ihres Mehrfamilienhauses'
    ]
  },
  {
    name: slideNames.SLIDE_6, // H - Bauweise
    messages: [
      'Ihre Wohnung',
      'Ihr Einfamilienhaus',
      'Ihre Doppelhaushälfte',
      'Ihr Reihenendhaus',
      'Ihr Einfamilienhaus',
      'Ihr Reihenmittelhaus',
      'Ihr Zweifamilienhaus',
      'Ihr Mehrfamilienhaus'
    ]
  },
  {
    name: slideNames.SLIDE_7, // H - Ausbau des Kellers
    messages: [
      'Ihre Wohnung',
      'Ihr Einfamilienhaus',
      'Ihre Doppelhaushälfte',
      'Ihr Reihenendhaus',
      'Ihr Einfamilienhaus',
      'Ihr Reihenmittelhaus',
      'Ihr Zweifamilienhaus',
      'Ihr Mehrfamilienhaus'
    ]
  },
  {
    name: slideNames.SLIDE_11, // H - Ausstattung (Gäste-WC, Kamin/Kachelofen, Bad, auf Putz …) HAUS
    messages: [
      'Ihre Wohnung',
      'Ihr Einfamilienhaus',
      'Ihre Doppelhaushälfte',
      'Ihr Reihenendhaus',
      'Ihr Einfamilienhaus',
      'Ihr Reihenmittelhaus',
      'Ihr Zweifamilienhaus',
      'Ihr Mehrfamilienhaus'
    ]
  },
  {
    name: slideNames.SLIDE_16, // HW - Energieeffizienzklasse & Energieeffizienshausstandard
    messages: [
      'Ihre Wohnung',
      'Ihr Einfamilienhaus',
      'Ihre Doppelhaushälfte',
      'Ihr Reihenendhaus',
      'Ihr Einfamilienhaus',
      'Ihr Reihenmittelhaus',
      'Ihr Zweifamilienhaus',
      'Ihr Mehrfamilienhaus'
    ]
  },
  {
    name: slideNames.SLIDE_17, // HW - Relevante Modernisierungen
    messages: [
      'Ihrer Wohnung',
      'Ihrem Einfamilienhaus',
      'Ihrer Doppelhaushälfte',
      'Ihrem Reihenendhaus',
      'Ihrem Einfamilienhaus',
      'Ihrem Reihenmittelhaus',
      'Ihrem Zweifamilienhaus',
      'Ihrem Mehrfamilienhaus'
    ]
  },
  {
    name: slideNames.SLIDE_19, // HW - Adresse der Immobilie
    messages: [
      'Ihrer Wohnung',
      'Ihres Einfamilienhauses',
      'Ihrer Doppelhaushälfte',
      'Ihres Reihenendhauses',
      'Ihres Einfamilienhauses',
      'Ihres Reihenmittelhauses',
      'Ihres Zweifamilienhauses',
      'Ihres Mehrfamilienhauses'
    ]
  }
]

export const propertyTypes = {
  HOUSE: 'haus',
  APARTMENT: 'wohnung'
}

export const design = {
  HAUSANKER: 'hausanker'
}
